import api, { getRestaurante } from '../../../../services/api';
import { getGoogleLink } from '../../FeedbackForm/services/api';
import { onlyDigits } from '../constants';

// Restaurante (id + slug + nome) — mesma fonte usada pelos produtos.
// `getRestaurante` já tenta várias rotas e devolve o registro com `checkin_slug`.
export const loadRestaurantInfo = async () => {
  const r = (await getRestaurante()) || {};
  return {
    id: r.id ?? r.restaurante_id ?? null,
    slug: r.checkin_slug || r.slug || '',
    name: r.nome || r.name || '',
  };
};

// Normaliza um telefone BR para o formato do wa.me (com DDI 55).
const toWhatsapp = (raw) => {
  let d = onlyDigits(raw);
  if (!d) return '';
  if (d.length <= 11 && !d.startsWith('55')) d = `55${d}`;
  return d;
};

// Número de atendimento configurado para a instância do AtendaBot.
// Números de transbordo e campos genéricos pertencem ao cliente/restaurante
// e não devem ser usados para montar o link público do bot.
export const loadAtendabotWhatsapp = async () => {
  try {
    const { data } = await api.get('/atendabot/config');
    const raw = data?.atendabot_phone || '';
    return raw ? toWhatsapp(raw) : '';
  } catch {
    return '';
  }
};

// Link do Google Reviews do restaurante (param `gl` do Feedback Hero).
export const loadGoogleReviewLink = async () => {
  try {
    const data = await getGoogleLink();
    return String(data?.google_review_url || '').trim();
  } catch {
    return '';
  }
};